import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { HtmlTruncatePreservePipe } from '../pipes/html-truncate-preserve.pipe';

@Directive({
  selector: '[appExpandableText]',
  standalone: false,
})
export class ExpandableTextDirective implements OnInit {
  @Input() appExpandableText: string = '';
  @Input() maxLength: number = 400;
  @Input() readMoreText: string = 'Read more';
  @Input() readLessText: string = 'Read less';

  private isExpanded: boolean = false;
  private originalContent: string = '';
  private needsTruncation: boolean = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private htmlTruncatePipe: HtmlTruncatePreservePipe
  ) {}

  ngOnInit() {
    this.originalContent = this.appExpandableText || this.el.nativeElement.innerHTML;
    this.checkIfTruncationNeeded();
    this.updateContent();
    this.setupClickListener();
  }

  private checkIfTruncationNeeded() {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.originalContent;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    this.needsTruncation = textContent.length > this.maxLength;
  }

  private updateContent() {
    if (!this.needsTruncation) {
      this.el.nativeElement.innerHTML = this.originalContent;
      return;
    }

    if (this.isExpanded) {
      const expandedContent = this.originalContent + ` <a href="#" class="read-less-link" onclick="return false;">${this.readLessText}</a>`;
      this.el.nativeElement.innerHTML = expandedContent;
    } else {
      const truncatedContent = this.htmlTruncatePipe.transform(this.originalContent, this.maxLength, this.readMoreText, true, 'directive');
      this.el.nativeElement.innerHTML = truncatedContent;
    }
  }

  private setupClickListener() {
    this.renderer.listen(this.el.nativeElement, 'click', (event) => {
      const target = event.target as HTMLElement;

      if (target.classList.contains('read-more-link') || target.classList.contains('read-less-link')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        this.isExpanded = !this.isExpanded;
        this.updateContent();
      }
    });
  }
}
